import { render } from "./headerBlock.vue?vue&type=template&id=f196721e"
import script from "./headerBlock.vue?vue&type=script&lang=js"
export * from "./headerBlock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__